import * as React from 'react';
import { SVGProps } from 'react';

const FileIconBmpSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 18H9v9.667L12 25l6 5 4-3 3 2.25V18H9.5ZM9 31.5v-2.167l3-2.81 5.906 4.797L22 28.25l3 2.25V32H9v-.5Zm-1-13V33h18V17H8v1.5Zm10 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 11.77c.22.153.487.23.8.23h.5c.587 0 1.017-.123 1.29-.37.273-.253.41-.663.41-1.23V8.6c0-.56-.137-.967-.41-1.22-.28-.253-.77-.38-1.35-.38H10V5H9v7h1v-.23Zm.65-.77c-.22 0-.383-.057-.49-.17a.565.565 0 0 1-.16-.38V8h1.25c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-.6Z"
      fill="#fff"
    />
    <path
      d="M15.5 7c.384 0 .735.144 1 .382a1.5 1.5 0 0 1 2.497 1.026L19 8.41V12h-1V8.5a.5.5 0 0 0-1 0V12h-1V8.5a.5.5 0 0 0-1 0V12h-1V7h.8v.173c.209-.11.447-.173.7-.173Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8 7.24V7H20v7h1.01v-2h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V8.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24L21 8.55a.53.53 0 0 1 .16-.37Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconBmpSizeM;
